
export const common = {
  // Navigation
  nav_shop: 'SHOP',
  nav_loadouts: 'LOADOUTS',
  nav_byd: 'BYD',
  nav_ai_assist: 'AI ASSIST',
  nav_wish: 'WISH',
  nav_menu: 'MENU',
  nav_search_title: 'Search (⌘K)',
  nav_cart_title: 'Your Loadouts',
  
  // Hero Section
  hero_season: 'SEASON 2026 • NEW ARRIVALS',
  hero_title_1: 'BUILD YOUR',
  hero_title_2: 'ULTIMATE SETUP',
  hero_description: 'Experience electronics shopping reimagined as an immersive game. Select your survilis, inspect every detail, and deploy with confidence.',
  hero_cta_shop: 'ENTER SHOP',
  hero_cta_ai: 'AI ASSISTANT',
  hero_scroll: 'Scroll to explore',
  hero_background_alt: 'Hero Background',
  
  // Featured Section
  featured_label: 'FEATURED',
  featured_title: 'LATEST DROPS',
  featured_view_all: 'VIEW ALL',

  // Popular Section
  popular_label: 'POPULAR',
  popular_title: 'POPULAR PRODUCTS',
  popular_empty: 'No popular products yet.',

  // Build Your Dream
  byd_label: 'BUILD',
  byd_title: 'Build Your Dream',
  byd_description: 'Select parts, check compatibility, and craft a custom PC build in minutes.',
  byd_part_select: 'Select a part type',
  byd_search_label: 'Search',
  byd_search_placeholder: 'Search by name or ID...',
  byd_filters_title: 'Filters',
  byd_filter_brand: 'Brand',
  byd_filter_price: 'Price Range',
  byd_price_min: 'Min',
  byd_price_max: 'Max',
  byd_results_title: 'Available parts',
  byd_results_empty: 'No parts match your filters.',
  byd_selected_title: 'Your Build',
  byd_selected_count: '{{count}} parts selected',
  byd_cart_label: 'Custom Build • {{count}} parts',
  byd_slot_add: 'Select part',
  byd_slot_empty: 'No part selected',
  byd_remove_part: 'Remove',
  byd_autofill_desc: 'Fill missing parts based on a price profile.',
  byd_mode_label: 'Mode: {{mode}}',
  byd_mode_cheapest: 'Cheapest',
  byd_mode_balanced: 'Balanced',
  byd_mode_random: 'Random',
  byd_mode_custom: 'Custom',
  byd_autofill_done: 'Auto-fill applied: {{mode}}',
  byd_compat_title: 'Compatibility Check',
  byd_compat_ok: 'All selected parts look compatible.',
  byd_compat_cpu_motherboard: 'CPU socket {{cpuSocket}} does not match motherboard socket {{mbSocket}}.',
  byd_compat_ram_motherboard: 'RAM type {{ramType}} does not match motherboard memory type {{mbType}}.',
  byd_compat_case_motherboard: 'Case form factor {{caseForm}} does not support motherboard form factor {{mbForm}}.',
  byd_compat_cooler_cpu: 'Cooler does not support CPU socket {{cpuSocket}}.',
  byd_compat_psu_power: 'Estimated power {{requiredWatt}}W exceeds PSU capacity {{psuWatt}}W.',
  byd_total_label: 'Build Total',
  byd_add_to_cart: 'Add Build to Cart',
  byd_add_disabled: 'Select at least 3 parts',
  byd_added_to_cart: 'Build added to cart',
  byd_custom_name: 'BYD - Custom Build',
  byd_custom_description: 'Custom BYD build assembled from selected parts.',
  byd_part_preview: 'Part Preview',
  byd_part_view: 'View Product',
  byd_part_cpu: 'CPU',
  byd_part_motherboard: 'Motherboard',
  byd_part_psu: 'PSU',
  byd_part_ram: 'RAM',
  byd_part_cooling: 'Cooling System',
  byd_part_case: 'Case',
  byd_part_gpu: 'GPU',
  byd_part_storage: 'Storage',
  byd_part_monitor: 'Monitor',
  byd_part_keyboard: 'Keyboard',
  byd_part_mouse: 'Mouse',
  byd_part_mouse_pad: 'Mouse Pad',
  byd_part_game_controller: 'Game Controller',
  byd_part_speakers: 'Speakers',
  byd_part_headset: 'Headset',
  byd_part_microphone: 'Microphone',
  byd_part_webcam: 'Webcam',
  byd_part_ups: 'UPS',
  byd_part_power_protection: 'Power Protection',
  byd_part_monitor_mount: 'Monitor Mount',
  byd_part_vr_headset: 'VR Headset',

  // Wish Page
  wish_label: 'WISH',
  wish_title: 'Request Your Dream Tech',
  wish_description: 'Tell us what you are looking for and we will source it for you, even if it is not listed in the shop.',
  wish_question: 'What are you wishing for?',
  wish_category_hint: 'Choose a category to shape your request.',
  wish_category_laptop: 'Laptop',
  wish_category_smartphone: 'Smartphone',
  wish_category_pc_parts: 'PC Parts',
  wish_category_other: 'Other',
  wish_exact_model: 'Exact model in mind?',
  wish_exact_hint: 'Pick yes if you already know the exact model.',
  wish_yes: 'YES',
  wish_no: 'NO',
  wish_model_name: 'Exact model name',
  wish_external_url: 'External product URL (optional)',
  wish_brand: 'Preferred brand',
  wish_use_case: 'Use case',
  wish_cpu: 'Desired CPU / Chipset',
  wish_ram: 'Desired RAM',
  wish_storage: 'Desired storage',
  wish_screen: 'Screen size',
  wish_color: 'Preferred color',
  wish_software: 'Software or apps you need',
  wish_other_name: 'Product name',
  wish_other_description: 'Describe what you need',
  wish_price_min: 'Budget from (₾)',
  wish_price_max: 'Budget to (₾)',
  wish_condition: 'Condition',
  wish_contact_title: 'Your contact details',
  wish_name: 'Full name',
  wish_phone: 'Phone number',
  wish_email: 'Email address',
  wish_submit: 'Send Wish',
  wish_submit_loading: 'Sending...',
  wish_confirm_title: 'Wish sent!',
  wish_confirm_desc: 'We received your request and will contact you soon.',
  wish_submit_another: 'Send another wish',
  wish_submit_success: 'Wish request submitted',
  wish_submit_error: 'Failed to submit wish request',
  wish_required_contact: 'Please fill in name, phone, and email.',
  wish_required_model: 'Please enter the exact model name.',
  wish_required_product: 'Please enter a product name.',

  // Wish Home Section
  wish_home_label: 'WISH',
  wish_home_title: "You don’t need a genie.",
  wish_home_description: 'Tell us exactly what you want and we will source it for you, even if it is not in our catalog.',
  wish_home_point_1: 'Laptop, PC build, or smartphone with specific specs.',
  wish_home_point_2: 'Hard-to-find models or special editions in your budget.',
  wish_home_point_3: 'We find it, verify it, and bring it to you.',
  wish_home_cta: 'Make a Wish',
  wish_home_side_title: 'Tired of endless searching?',
  wish_home_side_description: 'The perfect laptop, exact PC specs, or a phone that fits your budget may be just one request away.',
  wish_home_side_link: 'Open Wish Form',

  // Build Your Dream Home
  byd_home_label: 'BYD',
  byd_home_title: 'Build a dream rig without the guesswork.',
  byd_home_description: 'Choose parts, check compatibility, and generate a custom build that fits your budget.',
  byd_home_cta: 'Start Building',
  byd_home_side_title: 'From CPU to peripherals.',
  byd_home_side_description: 'Pick every component and let Survili assemble the perfect setup.',
  byd_home_side_link: 'Open Builder',
  
  // Loadouts Section
  loadouts_label: 'COMMUNITY',
  loadouts_title: 'TRENDING LOADOUTS',
  loadouts_description: 'Pre-configured setups curated by experts',
  loadouts_view: 'VIEW LOADOUTS',
  
  // AI Assistant Section
  ai_title: 'NEED GUIDANCE?',
  ai_description: 'Our AI assistant helps you find the perfect setup based on your needs, budget, and use case.',
  ai_cta: 'START AI CHAT',
  
  // Shop Page
  shop_title: 'CHOOSE YOUR GEAR',
  shop_description: 'Tune your preferences and find the perfect setup',
  shop_tuning: 'TUNING PANEL',
  shop_use_case: 'Use Case',
  shop_budget: 'Budget Range',
  shop_brands: 'Brands',
  shop_reset: 'RESET FILTERS',
  shop_products_found: 'products found',
  shop_sort: 'SORT BY',
  shop_category: 'Category',
  shop_category_laptops: 'Laptops',
  shop_category_pc_parts: 'PC Parts',
  shop_category_smartphones: 'Smartphones',
  shop_category_others: 'Others',
  shop_cpu_brand: 'CPU Brand',
  shop_gpu_type: 'GPU Type',
  shop_ram_gb: 'RAM (GB)',
  shop_memory_gb: 'Memory (GB)',
  shop_storage_gb: 'Storage (GB)',
  shop_screen_size: 'Screen Size (in)',
  shop_refresh_rate: 'Refresh Rate (Hz)',
  shop_part_type: 'Part Type',
  shop_form_factor: 'Form Factor',
  shop_chipset: 'Chipset / Socket',
  shop_os: 'OS',
  shop_battery: 'Battery',
  shop_camera: 'Camera',
  shop_5g: '5G',
  shop_5g_any: 'Any',
  shop_5g_only: '5G Only',
  shop_5g_no: 'No 5G',
  shop_accessory_type: 'Accessory Type',
  shop_compatibility: 'Compatibility',
  
  // Product Actions
  product_inspect: 'Inspect',
  product_add: 'Add to Cart',
  
  // Cart
  cart_title: 'YOUR SURVILIS',
  cart_empty: 'Your survilis are empty',
  cart_checkout: 'PROCEED TO CHECKOUT',
  cart_total: 'TOTAL',
  
  // Footer
  footer_tagline: 'Next-generation electronics shopping experience inspired by gaming interfaces.',
  footer_shop: 'Shop',
  footer_support: 'Support',
  footer_connect: 'Connect',
  footer_copyright: '© 2023 Project Survili. All rights reserved.',
  footer_powered: 'Powered by Survili.com',
  footer_shipping: 'Shipping',
  footer_terms: 'Terms',
  footer_about: 'About Us',
  footer_social_missing: 'Set in Admin → Settings',

  // Mission Bar
  mission_title: 'MISSION SURVILIS',
  mission_items_selected_one: '{{count}} item selected',
  mission_items_selected_other: '{{count}} items selected',
  mission_total_amount: 'Total Amount',
  mission_checkout: 'PROCEED TO CHECKOUT',
  mission_label: 'SURVILIS',

  // Pull to Refresh
  pull_refreshing: 'Refreshing...',
  pull_release: 'Release to refresh',
  pull_pull: 'Pull to refresh',
  
  // Common
  price_currency: 'GEL',
  loading: 'Loading...',
  back: 'BACK',

  // Product Page
  product_overview: 'OVERVIEW',
  product_specs: 'SPECS',
  product_compare: 'COMPARE',
  product_save: 'SAVE',
  product_share: 'SHARE',
  product_similar: 'SIMILAR GEAR',
  product_add_to_survili: 'ADD TO SURVILIS',
  product_back_shop: 'BACK TO SHOP',
  product_quantity: 'Quantity',
  product_performance: 'Performance Stats',
  product_tech_specs: 'Technical Specifications',
  product_ai_compare: 'AI Compare Mode',
  product_ai_compare_desc: 'Use our AI assistant to compare this product with alternatives and get personalized recommendations.',
  product_start_comparison: 'START AI COMPARISON',
  product_coming_soon: 'Coming soon!',
  condition_new: 'New',
  condition_used: 'Used',

  // Loadouts Page
  loadouts_page_title: 'LOADOUTS',
  loadouts_page_desc: 'Expert-curated product bundles for every need',
  loadouts_items: 'items',
  loadouts_total: 'Total',
  loadouts_view_details: 'VIEW DETAILS',

  // Checkout
  checkout_title: 'MISSION CONFIRM',
  checkout_subtitle: 'Complete your loadout acquisition',
  checkout_identity: 'Identity',
  checkout_delivery: 'Delivery',
  checkout_payment: 'Payment Method',
  checkout_order_summary: 'Order Summary',
  checkout_confirm: 'CONFIRM',
  checkout_continue: 'Continue',
  checkout_wire: 'Wire',
  checkout_card: 'Card',
  checkout_installment: 'Installment',

  // Reviews
  reviews_title: 'Customer Reviews',
  reviews_write: 'Write a Review',
  reviews_submit: 'Submit Review',
  reviews_name: 'Your Name',
  reviews_rating: 'Rating',
  reviews_comment: 'Your Review',
  reviews_no_reviews: 'No reviews yet. Be the first!',

  // Sort Options
  sort_newest: 'Newest First',
  sort_price_low: 'Price: Low to High',
  sort_price_high: 'Price: High to Low',
  sort_name_asc: 'Name: A to Z',
  sort_name_desc: 'Name: Z to A',

  // Not Found
  notfound_title: 'MISSION FAILED',
  notfound_subtitle: 'Target location not found',
  notfound_return_home: 'RETURN TO BASE',
  notfound_browse_shop: 'BROWSE SHOP',

  // Toasts
  toast_added_to_cart: 'Added {{name}} to your Loadouts!',
  toast_added_to_cart_qty: 'Added {{count}}x {{name}} to your Loadouts!',
  toast_save_coming: 'Save feature coming soon!',
  toast_link_copied: 'Link copied to clipboard!',
  toast_review_missing: 'Please fill in your name and comment',
  toast_review_success: 'Review submitted successfully!',
  toast_review_error: 'Failed to submit review. Please try again.',
  toast_iban_copied: 'IBAN copied to clipboard!',
  toast_redirecting_payment: 'Redirecting to payment page...',
  toast_payment_unavailable: 'Payment service unavailable. Please try wire transfer.',
  toast_order_failed: 'Failed to create order. Please try again.',

  // Shop Extras
  shop_badge: 'SURVILIS SELECT',
  shop_usecase_gaming: 'Gaming',
  shop_usecase_office: 'Office',
  shop_usecase_editing: 'Editing',
  shop_usecase_student: 'Student',

  // Stat Labels
  stat_short_performance: 'Perf',
  stat_short_battery: 'Batt',
  stat_short_display: 'Disp',
  stat_short_portability: 'Port',
  stat_short_upgradeability: 'Upgr',
  stat_label_performance: 'Performance',
  stat_label_battery: 'Battery',
  stat_label_display: 'Display',
  stat_label_portability: 'Portability',
  stat_label_upgradeability: 'Upgradeability',

  // Specs
  spec_cpu: 'CPU',
  spec_gpu: 'GPU',
  spec_ram: 'RAM',
  spec_storage: 'Storage',
  spec_display: 'Display',
  spec_cpu_brand: 'CPU Brand',
  spec_gpu_type: 'GPU Type',
  spec_ram_gb: 'RAM (GB)',
  spec_storage_gb: 'Storage (GB)',
  spec_screen_size_in: 'Screen Size (in)',
  spec_refresh_hz: 'Refresh Rate (Hz)',
  spec_pc_part_type: 'Part Type',
  spec_form_factor: 'Form Factor',
  spec_chipset: 'Chipset / Socket',
  spec_os: 'OS',
  spec_battery_mah: 'Battery (mAh)',
  spec_camera_mp: 'Camera (MP)',
  spec_supports_5g: 'Supports 5G',
  spec_accessory_type: 'Accessory Type',
  spec_compatibility: 'Compatibility',
  spec_cpu_manufacturer: 'CPU Manufacturer',
  spec_cpu_model_name: 'CPU Model',
  spec_cpu_series: 'CPU Series',
  spec_cpu_socket: 'CPU Socket',
  spec_cpu_generation: 'CPU Generation',
  spec_cpu_cores: 'CPU Cores',
  spec_cpu_threads: 'CPU Threads',
  spec_cpu_base_clock_ghz: 'CPU Base Clock (GHz)',
  spec_cpu_boost_clock_ghz: 'CPU Boost Clock (GHz)',
  spec_cpu_tdp_watt: 'CPU TDP (W)',
  spec_cpu_integrated_graphics: 'Integrated Graphics',
  spec_cpu_cooler_included: 'Cooler Included',
  spec_motherboard_manufacturer: 'Motherboard Manufacturer',
  spec_motherboard_model_name: 'Motherboard Model',
  spec_motherboard_socket: 'Motherboard Socket',
  spec_motherboard_chipset: 'Motherboard Chipset',
  spec_motherboard_form_factor: 'Motherboard Form Factor',
  spec_motherboard_memory_type: 'Memory Type',
  spec_motherboard_memory_slots: 'Memory Slots',
  spec_motherboard_max_memory_gb: 'Max Memory (GB)',
  spec_motherboard_pcie_version: 'PCIe Version',
  spec_motherboard_m2_slots: 'M.2 Slots',
  spec_motherboard_sata_ports: 'SATA Ports',
  spec_motherboard_ethernet_speed: 'Ethernet Speed',
  spec_motherboard_wifi: 'Wi-Fi',
  spec_motherboard_bluetooth: 'Bluetooth',
  spec_motherboard_bios_flashback: 'BIOS Flashback',
  spec_psu_manufacturer: 'PSU Manufacturer',
  spec_psu_model_name: 'PSU Model',
  spec_psu_wattage: 'PSU Wattage',
  spec_psu_efficiency_rating: 'Efficiency Rating',
  spec_psu_modularity: 'Modularity',
  spec_psu_form_factor: 'PSU Form Factor',
  spec_psu_fan_size_mm: 'Fan Size (mm)',
  spec_psu_protections: 'Protections',
  spec_ram_manufacturer: 'RAM Manufacturer',
  spec_ram_model_name: 'RAM Model',
  spec_ram_memory_type: 'RAM Type',
  spec_ram_capacity_gb: 'RAM Capacity (GB)',
  spec_ram_kit_configuration: 'RAM Kit',
  spec_ram_speed_mhz: 'RAM Speed (MHz)',
  spec_ram_latency_cl: 'RAM Latency (CL)',
  spec_ram_voltage_v: 'RAM Voltage (V)',
  spec_ram_rgb: 'RAM RGB',
  spec_cooler_type: 'Cooler Type',
  spec_cooler_supported_sockets: 'Supported Sockets',
  spec_cooler_radiator_size_mm: 'Radiator Size (mm)',
  spec_cooler_fan_count: 'Fan Count',
  spec_cooler_noise_level_db: 'Noise Level (dB)',
  spec_cooler_rgb: 'Cooler RGB',
  spec_case_manufacturer: 'Case Manufacturer',
  spec_case_model_name: 'Case Model',
  spec_case_type: 'Case Type',
  spec_case_supported_form_factors: 'Supported Form Factors',
  spec_case_material: 'Case Material',
  spec_case_included_fans: 'Included Fans',
  spec_case_rgb: 'Case RGB',
  spec_case_color: 'Case Color',
  spec_gpu_manufacturer: 'GPU Manufacturer',
  spec_gpu_brand_partner: 'GPU Brand Partner',
  spec_gpu_model_name: 'GPU Model',
  spec_gpu_chipset: 'GPU Chipset',
  spec_gpu_vram_gb: 'VRAM (GB)',
  spec_gpu_memory_type: 'GPU Memory Type',
  spec_gpu_pcie_version: 'GPU PCIe Version',
  spec_gpu_power_connector: 'Power Connector',
  spec_gpu_power_watt: 'GPU Power (W)',
  spec_storage_type: 'Storage Type',
  spec_storage_capacity_gb: 'Storage Capacity (GB)',
  spec_storage_form_factor: 'Storage Form Factor',
  spec_storage_interface: 'Storage Interface',
  spec_storage_read_speed_mb_s: 'Read Speed (MB/s)',
  spec_storage_write_speed_mb_s: 'Write Speed (MB/s)',
  spec_monitor_screen_size_inch: 'Screen Size (inch)',
  spec_monitor_resolution: 'Resolution',
  spec_monitor_panel_type: 'Panel Type',
  spec_monitor_refresh_rate_hz: 'Refresh Rate (Hz)',
  spec_monitor_response_time_ms: 'Response Time (ms)',
  spec_monitor_ports: 'Ports',
  spec_monitor_vesa_mount: 'VESA Mount',
  spec_keyboard_type: 'Keyboard Type',
  spec_keyboard_layout: 'Layout',
  spec_keyboard_switch_type: 'Switch Type',
  spec_keyboard_connection: 'Connection',
  spec_keyboard_rgb: 'Keyboard RGB',
  spec_keyboard_language_layout: 'Language Layout',
  spec_mouse_sensor_type: 'Sensor Type',
  spec_mouse_dpi_max: 'DPI Max',
  spec_mouse_buttons: 'Buttons',
  spec_mouse_connection: 'Connection',
  spec_mouse_rgb: 'Mouse RGB',
  spec_mousepad_size: 'Mouse Pad Size',
  spec_mousepad_surface_type: 'Surface Type',
  spec_mousepad_rgb: 'Mouse Pad RGB',
  spec_controller_type: 'Controller Type',
  spec_controller_platform_support: 'Platform Support',
  spec_controller_connection: 'Connection',
  spec_speakers_channel_configuration: 'Channels',
  spec_speakers_power_watt: 'Power (W)',
  spec_speakers_connection: 'Connection',
  spec_headset_type: 'Headset Type',
  spec_headset_connection: 'Connection',
  spec_headset_microphone: 'Microphone',
  spec_headset_surround_sound: 'Surround Sound',
  spec_microphone_type: 'Microphone Type',
  spec_microphone_pickup_pattern: 'Pickup Pattern',
  spec_microphone_frequency_response_hz: 'Frequency Response',
  spec_webcam_resolution: 'Webcam Resolution',
  spec_webcam_frame_rate_fps: 'Frame Rate (FPS)',
  spec_webcam_autofocus: 'Autofocus',
  spec_webcam_microphone: 'Microphone',
  spec_ups_capacity_va: 'Capacity (VA)',
  spec_ups_output_watt: 'Output (W)',
  spec_ups_type: 'UPS Type',
  spec_ups_outlets: 'Outlets',
  spec_power_protection_type: 'Protection Type',
  spec_power_protection_outlets: 'Outlets',
  spec_power_protection_max_load_watt: 'Max Load (W)',
  spec_monitor_mount_type: 'Mount Type',
  spec_monitor_mount_vesa_support: 'VESA Support',
  spec_monitor_mount_max_screen_size_inch: 'Max Screen Size (inch)',
  spec_monitor_mount_adjustment: 'Adjustment',
  spec_vr_platform_support: 'VR Platform',
  spec_vr_resolution_per_eye: 'Resolution per Eye',
  spec_vr_refresh_rate_hz: 'VR Refresh Rate (Hz)',
  spec_vr_tracking_type: 'Tracking Type',
  spec_vr_connection: 'VR Connection',
  product_specs_empty: 'No specifications available for this product.',
  product_not_found_title: 'Product Not Found',
  product_not_found_back: 'Return to Shop',
  breadcrumb_home: 'Home',
  breadcrumb_shop: 'Shop',

  // Loadouts
  loadouts_empty_title: 'No Loadouts Yet',
  loadouts_empty_desc: 'Check back soon for curated setups',
  loadouts_browse_shop: 'BROWSE SHOP',
  loadout_not_found_title: 'Loadout not found.',
  loadout_not_found_back: 'Go back home',
  loadout_add_all: 'Add All to Cart & Checkout',
  loadout_products_title: 'Products in this Loadout',
  loadout_products_empty: 'No products found for this Loadout.',

  // Search
  search_placeholder: 'Search products, categories, brands...',
  search_hint_close: 'to close',
  search_hint_search: 'to search',
  search_loading: 'Searching...',
  search_results_one: '{{count}} result found',
  search_results_other: '{{count}} results found',
  search_no_results_title: 'No results found',
  search_no_results_message: 'Try different keywords or browse our',
  search_no_results_shop: 'shop',
  search_recent: 'Recent Searches',
  search_clear: 'Clear all',
  search_start_title: 'Start searching',
  search_start_desc: 'Find products by name, category, or brand',
  search_quick_links: 'Quick Links',
  search_quick_all_products: 'All Products',
  search_quick_loadouts: 'Loadouts',
  search_quick_gaming: 'Gaming',
  search_quick_laptops: 'Laptops',

  // Reviews
  reviews_summary_one: '{{rating}} out of 5 ({{count}} review)',
  reviews_summary_other: '{{rating}} out of 5 ({{count}} reviews)',
  reviews_write_title: 'Write Your Review',
  reviews_name_required: 'Your Name *',
  reviews_rating_label: 'Rating *',
  reviews_title_optional: 'Review Title (optional)',
  reviews_title_placeholder: 'Summarize your experience',
  reviews_name_placeholder: 'Enter your name',
  reviews_comment_label: 'Your Review *',
  reviews_comment_placeholder: 'Share your experience with this product...',
  reviews_cancel: 'Cancel',
  reviews_verified: 'Verified',

  // Checkout Extras
  checkout_empty_desc: 'Add some items to proceed',
  checkout_complete_title: 'MISSION COMPLETE!',
  checkout_complete_desc: 'Your order has been confirmed',
  checkout_order_id_label: 'Order ID',
  checkout_back: 'Back',
  checkout_processing: 'Processing...',
  checkout_full_name: 'Full Name',
  checkout_email: 'Email',
  checkout_phone: 'Phone',
  checkout_address: 'Address',
  checkout_city: 'City',
  checkout_payment_card_title: 'BOG Card Payment',
  checkout_payment_card_desc: 'You will be redirected to BOG payment gateway to complete your payment securely.',
  checkout_payment_card_soon_title: 'Card Payment Coming Soon',
  checkout_payment_card_soon_desc: 'Card payment is being set up. Please use wire transfer for now.',
  checkout_installment_bog_desc: 'You will be redirected to BOG to complete the installment process.',
  checkout_installment_pending_desc: 'Selected installment plan will be processed after order confirmation.',
  checkout_installment_change: 'Change selection',
  checkout_installment_confirm: 'Continue with BOG',
  checkout_installment_title: 'BOG Installment',
  checkout_installment_rate_title: 'Installment from effective 26%',
  checkout_installment_rate_body1: 'Schedule tailored to you',
  checkout_installment_rate_body2: 'Simple conditions',
  checkout_installment_months_label: 'Choose installment term',
  checkout_bnpl_title: 'BOG BNPL',
  checkout_bnpl_desc: 'Split into 4 equal parts · First payment in 1 month · No hidden fees',
  checkout_bnpl_short: 'BNPL',
  checkout_installment_short: 'Installment',
  checkout_bnpl_payment_1: '1st payment',
  checkout_bnpl_payment_2: '2nd payment',
  checkout_bnpl_payment_3: '3rd payment',
  checkout_bnpl_payment_4: '4th payment',
  checkout_order_summary_title: 'Order Summary',
  checkout_total_label: 'Total',
  checkout_installment_select_title: 'Select Installment Plan',
  checkout_installment_coming_soon: 'Coming Soon',

  // Payment Success
  payment_success_title: 'MISSION COMPLETE!',
  payment_success_message: 'Payment successful. Your order is being processed.',
  payment_success_order_id: 'Order ID',
  payment_success_amount_paid: 'Amount Paid',
  payment_success_next_title: 'What happens next?',
  payment_success_next_1: "You'll receive an order confirmation via SMS",
  payment_success_next_2: 'Our team will prepare your items for shipping',
  payment_success_next_3: "You'll be notified when your order ships",
  payment_success_continue: 'Continue Shopping',
  payment_success_go_home: 'Go Home',

  // Payment Fail
  payment_fail_title: 'MISSION FAILED',
  payment_fail_message: 'Payment was not completed. Please try again.',
  payment_fail_panel_title: 'Payment Unsuccessful',
  payment_fail_panel_desc: 'The payment was cancelled or declined. Your order has not been processed and no charges were made.',
  payment_fail_order_ref: 'Order Reference',
  payment_fail_help_title: 'What can you do?',
  payment_fail_help_1: 'Try again with a different payment method',
  payment_fail_help_2: 'Check your card details and balance',
  payment_fail_help_3: 'Contact your bank if the issue persists',
  payment_fail_try_again: 'Try Again',
  payment_fail_get_help: 'Get Help',
  payment_fail_back_shop: 'Back to Shop',

  // AI Assistant
  ai_assistant_title: 'AI Assistant – Coming Soon',
  ai_assistant_desc: "We're working on an in-game AI companion that will help you pick the perfect setup.",
  ai_assistant_back: 'Back to Home',

  // Shipping Policy
  shipping_seo_title: 'Shipping Policy | Project Survili',
  shipping_seo_desc: 'Learn about our shipping options, delivery times, and shipping costs for electronics orders in Georgia.',
  shipping_badge: 'DELIVERY INFO',
  shipping_title: 'Shipping Policy',
  shipping_subtitle: 'Fast and secure delivery across Georgia',
  shipping_zones_title: 'Delivery Zones',
  shipping_zone_tbilisi_title: 'Tbilisi',
  shipping_zone_tbilisi_desc: 'Free delivery for orders over ₾200. Standard delivery: ₾10',
  shipping_zone_cities_title: 'Batumi, Kutaisi, Rustavi',
  shipping_zone_cities_desc: 'Standard delivery: ₾15-20 depending on location',
  shipping_zone_other_title: 'Other Regions',
  shipping_zone_other_desc: 'Delivery available via courier service. Cost calculated at checkout.',
  shipping_times_title: 'Delivery Times',
  shipping_express_label: 'Express Delivery',
  shipping_express_time: 'Same Day',
  shipping_express_desc: 'Orders placed before 2 PM (Tbilisi only)',
  shipping_standard_label: 'Standard Delivery',
  shipping_standard_time: '1-3 Days',
  shipping_standard_desc: 'Available nationwide',
  shipping_tracking_title: 'Order Tracking',
  shipping_tracking_desc: 'Once your order is shipped, you will receive an SMS and email notification with tracking information. You can track your order status by contacting our support team.',
  shipping_whatsapp_support: 'WhatsApp Support',
  shipping_important_title: 'Important Notes',
  shipping_note_1: 'Please ensure someone is available to receive the package at the delivery address.',
  shipping_note_2: 'Delivery times may vary during holidays and peak seasons.',
  shipping_note_3: 'All products are carefully packaged to ensure safe delivery.',
  shipping_note_4: 'Inspect your package upon delivery and report any damage immediately.',

  // About Us
  about_seo_title: 'About Us | Project Survili',
  about_seo_desc: "Learn about Project Survili - Georgia's game-style electronics shop. Discover our mission, team, and warranty policies.",
  about_badge: 'WHO WE ARE',
  about_title: 'About Us',
  about_subtitle: 'Redefining electronics shopping in Georgia',
  about_nav_about: 'About Us',
  about_nav_warranty: 'Warranty',
  about_mission_title: 'Our Mission',
  about_mission_body: 'Project Survili transforms the way you shop for electronics. We\'ve reimagined the online shopping experience as an immersive game, where every product is a "survilis" (loadout) waiting to be deployed in your daily missions.',
  about_stat_products: 'Products',
  about_stat_customers: 'Happy Customers',
  about_stat_support: 'Support',
  about_values_title: 'Our Values',
  about_value_quality_title: 'Quality First',
  about_value_quality_desc: 'We only sell products we believe in. Every item is inspected for quality.',
  about_value_pricing_title: 'Fair Pricing',
  about_value_pricing_desc: 'Competitive prices without compromising on quality or service.',
  about_value_customer_title: 'Customer First',
  about_value_customer_desc: "Your satisfaction is our priority. We're here to help 24/7.",
  about_value_innovation_title: 'Innovation',
  about_value_innovation_desc: 'Constantly improving our platform for a better experience.',
  about_contact_title: 'Get in Touch',
  about_contact_whatsapp: 'WhatsApp',
  about_contact_phone: 'Phone',
  about_contact_email: 'Email',
  about_contact_instagram: 'Instagram',
  about_warranty_title: 'Warranty Policy',
  about_warranty_overview: 'We stand behind every product we sell. All items come with manufacturer warranty, and we provide additional support to ensure your complete satisfaction.',
  about_warranty_standard_title: 'Standard Warranty',
  about_warranty_standard_desc: '12 months manufacturer warranty on all products',
  about_warranty_extended_title: 'Extended Options',
  about_warranty_extended_desc: 'Extended warranty available on select products',
  about_warranty_covered_title: "What's Covered",
  about_warranty_covered_label: 'Covered',
  about_warranty_not_covered_label: 'Not Covered',
  about_warranty_covered_1: 'Manufacturing defects',
  about_warranty_covered_2: 'Hardware malfunctions',
  about_warranty_covered_3: 'Dead pixels (within policy limits)',
  about_warranty_covered_4: 'Battery defects',
  about_warranty_not_covered_1: 'Physical damage',
  about_warranty_not_covered_2: 'Water damage',
  about_warranty_not_covered_3: 'Unauthorized modifications',
  about_warranty_not_covered_4: 'Normal wear and tear',
  about_warranty_claim_title: 'How to Claim Warranty',
  about_warranty_step1_title: 'Contact Us',
  about_warranty_step1_desc: 'Reach out via WhatsApp or phone with your order details and issue description.',
  about_warranty_step2_title: 'Diagnosis',
  about_warranty_step2_desc: 'Our team will assess the issue and determine warranty eligibility.',
  about_warranty_step3_title: 'Resolution',
  about_warranty_step3_desc: "We'll repair, replace, or refund according to our warranty policy.",
  about_return_title: '14-Day Return Policy',
  about_return_desc: 'Changed your mind? You can return unopened products within 14 days of delivery for a full refund. The product must be in its original packaging with all accessories included.',
  about_return_bullet1: 'Product must be unused and in original condition',
  about_return_bullet2: 'Original receipt or proof of purchase required',
  about_return_bullet3: 'Return shipping costs may apply',
  about_last_updated: 'Last updated: December 2023',

  // Terms & Privacy
  terms_seo_title: 'Terms & Privacy | Project Survili',
  terms_seo_desc: 'Read our Terms of Service and Privacy Policy. Understand how we handle your data and the rules governing your use of Project Survili.',
  terms_badge: 'LEGAL INFORMATION',
  terms_title: 'Terms & Privacy',
  terms_subtitle: 'Your rights and our commitments',
  terms_nav_terms: 'Terms of Service',
  terms_nav_privacy: 'Privacy Policy',
  terms_section_title: 'Terms of Service',
  terms_accept_title: '1. Acceptance of Terms',
  terms_accept_body: 'By accessing and using Project Survili, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
  terms_products_title: '2. Products and Orders',
  terms_products_bullet1: 'All products are subject to availability.',
  terms_products_bullet2: 'Prices are in Georgian Lari (GEL) and may change without notice.',
  terms_products_bullet3: 'We reserve the right to refuse or cancel orders.',
  terms_products_bullet4: 'Order confirmation does not guarantee availability until shipped.',
  terms_payment_title: '3. Payment',
  terms_payment_body: 'Payment must be made at the time of order. We accept various payment methods including card payments and cash on delivery where available. All transactions are processed securely.',
  terms_conduct_title: '4. User Conduct',
  terms_conduct_intro: 'You agree not to:',
  terms_conduct_bullet1: 'Use the service for any unlawful purpose.',
  terms_conduct_bullet2: 'Attempt to interfere with the proper functioning of the website.',
  terms_conduct_bullet3: 'Submit false or misleading information.',
  terms_liability_title: '5. Limitation of Liability',
  terms_liability_body: 'Project Survili shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our services. Our total liability shall not exceed the amount paid for the product in question.',
  privacy_section_title: 'Privacy Policy',
  privacy_collect_title: 'Information We Collect',
  privacy_collect_body: 'To process your orders, we collect the following information:',
  privacy_collect_fullname: 'Full Name',
  privacy_collect_phone: 'Phone Number',
  privacy_collect_email: 'Email Address',
  privacy_collect_address: 'Delivery Address',
  privacy_use_title: 'How We Use Your Information',
  privacy_use_bullet1: 'Processing and delivering your orders.',
  privacy_use_bullet2: 'Communicating about your order status.',
  privacy_use_bullet3: 'Providing customer support.',
  privacy_use_bullet4: 'Improving our services and user experience.',
  privacy_data_title: 'Data Protection',
  privacy_data_card_title: 'Your data is secure',
  privacy_data_card_body: 'We implement industry-standard security measures to protect your personal information. We do not sell or share your data with third parties except as required for order fulfillment.',
  privacy_cookies_title: 'Cookies',
  privacy_cookies_body: 'We use cookies to enhance your browsing experience, including remembering your cart items and language preferences. You can disable cookies in your browser settings, but this may affect site functionality.',
  privacy_rights_title: 'Your Rights',
  privacy_rights_intro: 'You have the right to:',
  privacy_rights_bullet1: 'Request access to your personal data.',
  privacy_rights_bullet2: 'Request correction of inaccurate data.',
  privacy_rights_bullet3: 'Request deletion of your data (where applicable).',
  privacy_questions_title: 'Questions?',
  privacy_questions_body: 'If you have any questions about our Terms of Service or Privacy Policy, please contact us:',
  terms_last_updated: 'Last updated: December 2023',
};

export default common;
